import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Typography } from "@mui/material";

import { v4 as uuid } from "uuid";
import Link from "@mui/material/Link";
import { useSelector, useDispatch } from "react-redux";
import { goToPage } from "../redux/pageSlice";

function groupConsecutivePages(pages) {
  const groupedPages = [];
  let start = pages[0];
  let end = start;

  for (let i = 1; i < pages.length; i++) {
    if (pages[i] - end === 1) {
      end = pages[i];
    } else {
      groupedPages.push(start === end ? start : `${start}-${end}`);
      start = end = pages[i];
    }
  }
  groupedPages.push(start === end ? start : `${start}-${end}`);
  return groupedPages;
}

function extractPageGroups(data) {
  let result = [];
  for (let i = 0; i < data.length - 3; i++) {
    if (data[i]["Pages"]) {
      let pages = data[i]["Pages"];
      result.push([pages[0], pages[pages.length - 1]]);
    }
  }
  return result;
}

function splitIntoPackets(pages, packets) {
  const result = [];
  
  packets.forEach(packet => {
    const packetStart = packet[0];
    const packetEnd = packet[1];
    const pagesInPacket = pages.filter(page => page >= packetStart && page <= packetEnd);
    
    if (pagesInPacket.length > 0) {
      const start = pagesInPacket[0];
      const end = pagesInPacket[pagesInPacket.length - 1];
      result.push(start === end ? start : `${start}-${end}`);
    }
  });

  return result;
}

function extractSocialHistory(data) {
  var socialHistory = data[data.length - 3];
  var dataNoMedicalHist = [];
  var dataMedicalHist = [];
  //   console.log(Object.fromEntries(Object.entries(socialHistory).slice(0, -2)));
  //Parsing through all data in the social history that isn't medical history
  for (var category in Object.fromEntries(
    Object.entries(socialHistory).slice(0, -2)
  )) {
    if (category != "DEPENDENTS") {
      var pages = socialHistory[category]["Pages"];
      var info = socialHistory[category]["Summary"];
      //   console.log(category, pages, info);
    } else {
      var dependents = socialHistory[category];
      var info = "";
      var pages = "";
      for (var d in dependents) {
        info += d;
        pages += dependents[d];
      }
      //   console.log(category, pages, info);
    }
    const id = uuid();
    dataNoMedicalHist.push({ category, info, pages, id });
  }
  //   console.log(dataNoMedicalHist);
  //Parsing through data in medical history
  var medicalHist = socialHistory["PREV CONDITIONS"];
  for (var condition in medicalHist) {
    var pages = medicalHist[condition];
    const id = uuid();
    dataMedicalHist.push({ condition, pages, id });
  }
  //   console.log(dataMedicalHist);

  return [dataNoMedicalHist, dataMedicalHist];
}

export default function SocialHistory({ data }) {

  var packets = extractPageGroups(data);
  for(let i = 0; i < packets.length; i++) {
    console.log(packets[i])
  }

  var result = extractSocialHistory(data);
  var rowsNMH = result[0];
  var rowsMH = result[1];
  const dispatch = useDispatch();

  const handleClick = (value) => () => {
    console.log(value);
    dispatch(goToPage(value));
  };

  if (rowsNMH.length == 0) {
    return (
      <>
        <p align="center">
          No social history could be extracted; see PDF for more.
        </p>
      </>
    );
  }

  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        maxWidth: "100%",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
      }}
    >
      <Table
        sx={{ width: "100%", maxWidth: "100%" }}
        size="small"
        aria-label="a dense table"
      >
        <TableHead>
          <TableRow>
            <TableCell colSpan={3}>
              <Typography variant="h6" id="tableTitle" component="div">
                Social History
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              align="left"
              style={{ width: "175px", maxWidth: "175px" }}
            >
              Category
            </TableCell>
            <TableCell align="left" style={{ width: "50%", maxWidth: "50%" }}>
              Information
            </TableCell>
            <TableCell align="left" style={{ width: "20%", maxWidth: "20%" }}>
              Pages
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rowsNMH.map((row) => (
            <TableRow
              key={row.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell
                component="th"
                scope="row"
                style={{
                  width: "210px",
                  maxWidth: "210px",
                  overflowWrap: "break-word",
                }}
              >
                {row.category}
              </TableCell>
              <TableCell
                align="left"
                style={{
                  width: "50%",
                  maxWidth: "50%",
                  overflowWrap: "break-word",
                }}
              >
                {row.info}
              </TableCell>
              <TableCell align="left" style={{ width: "20%", maxWidth: "20%" }}>
                {splitIntoPackets(row.pages, packets).map((p, indx) => {
                  if (indx !== 0) {
                    return (
                      <Link
                        key={p}
                        style={{ cursor: "pointer" }}
                        onClick={handleClick(p)}
                      >
                        {", " + p}
                      </Link>
                    );
                  } else {
                    return (
                      <Link
                        key={p}
                        style={{ cursor: "pointer" }}
                        onClick={handleClick(p)}
                      >
                        {p}
                      </Link>
                    );
                  }
                })}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Table
        stickyHeader
        sx={{ width: "100%", maxWidth: "100%", paddingTop: "2rem" }}
        size="small"
        aria-label="a dense table"
      >
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography
                variant="h6"
                id="tableTitle"
                component="div"
                colSpan={3}
              >
                Past Medical Conditions
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              align="left"
              style={{ width: "175px", maxWidth: "175px" }}
            >
              Condition
            </TableCell>
            <TableCell align="left" style={{ width: "20%", maxWidth: "20%" }}>
              Pages
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rowsMH.map((row) => (
            <TableRow
              key={row.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell
                component="th"
                scope="row"
                style={{
                  width: "175px",
                  maxWidth: "175px",
                  overflowWrap: "break-word",
                }}
              >
                <div style={{ maxWidth: "80%" }}>{row.condition}</div>
              </TableCell>

              <TableCell align="left" style={{ width: "20%", maxWidth: "20%" }}>
                {splitIntoPackets(row.pages, packets).map((p, indx) => {
                  if (indx !== 0) {
                    return (
                      <Link
                        key={p}
                        style={{ cursor: "pointer" }}
                        onClick={handleClick(p)}
                      >
                        {", " + p}
                      </Link>
                    );
                  } else {
                    return (
                      <Link
                        key={p}
                        style={{ cursor: "pointer" }}
                        onClick={handleClick(p)}
                      >
                        {p}
                      </Link>
                    );
                  }
                })}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
